import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  Modal as AntModal,
  ModalFooter,
} from 'reactstrap'
import { IoIosCloseCircle } from 'react-icons/io'
import { AiOutlineSave } from 'react-icons/ai'

import { BillingDetail } from './billing-detail'
import { ListDetail } from './list-detail'
import { Button } from '../../../../buttons'
import { FONTS } from '../../../../../constants'

export const EditARBilling = ({ isEdit, data, handleClose, editDetail }) => {
  const { billing = {}, billing_id } = data
  const { accountant_billings = [], billings = [], revenue_allocation = [] } = billing

  const [detailState, setDetailState] = useState({})
  const [milestone, setMilestone] = useState({})

  useEffect(() => {
    if (data) {
      const milestone = billings.find(a => a.billing_id === billing_id) || null
      const accBilling = accountant_billings.find(a => a.billing_id === billing_id) || null
      setDetailState({
        ...accBilling,
        pm_remark: milestone ? milestone.remark : '',
        status: milestone ? milestone.status : null,
        vat: milestone ? milestone.vat : null,
      })
      setMilestone(milestone)
    }
  }, [data])

  const handleInput = (e, name) => {
    setDetailState({ ...detailState, [name]: e })
  }

  return (
    <Modal
      size='lg'
      isOpen={ isEdit }
      toggle={ handleClose }
    >
      <ModalHeader toggle={ handleClose }>
        <HeaderText>AR Billing Details</HeaderText>
        <AlignCenterWrapper>
          {/* <StatusText>Status</StatusText>
          <DrodownWrapper>
            <CustomSearchSelect placeholder='Select Status' options={ status } />
          </DrodownWrapper> */}
          <IoIosCloseCircle onClick={ handleClose } />
        </AlignCenterWrapper>
      </ModalHeader>

      <BodyWrapper>
        <BillingDetail
          data={ detailState }
          billing={ billing }
          targetBilling={ milestone }
          handleInput={ handleInput }
        />
        <ListDetail
          data={ milestone }
          revenueAllocation={ revenue_allocation }
        />
      </BodyWrapper>

      <ModalFooter>
        <ButtonGroup>
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => editDetail(billing._id, milestone.billing_id, detailState) }
          >
              Save
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ handleClose }
          >
              Cancel
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  )
}

const Modal = styled(AntModal)`
  .modal-header {
    border: none;
  }

  .modal-footer {
    border: none;
    background: #F9F9F9;
  }
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px 0 16px;

  svg {
      font-size: 24px;
      color: #C4C4C4;
      cursor: pointer;
  }
`

// const DrodownWrapper = styled.div`
//   width: 150px;
//   display: flex;
//   align-items: center;
//   margin: 0 16px;
// `

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 500px;
  overflow-y: scroll;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 28px 16px 0 16px;
`

const Row = styled.div`
  display: flex;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;

  div:nth-child(1) {
    margin-right: 12px;
  }
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`

// const StatusText = styled.span`
//   font-family: ${FONTS.GOTHAM};
//   font-size: ${FONTS.NORMAL_SIZE};
//   color: #1A1A17;
// `



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ar-billing/edit-billing/index.js